<!--
   Created by qing on 2020/2/27 3:45 下午
   Des:
-->
<template>
  <div class="ry-form-item__attachment">
    <van-cell class="ry-form__attachment normal-style" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">
        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <van-button
          :loading="showLoading"
          v-if="!isRead"
          :disabled="isReadOnly"
          icon="upgrade"
          size="small"
          type="info"
          @click="selectFile">
          上传文件
        </van-button>
        <van-swipe-cell
          class="ry-form__file-item"
          v-for="(file, idx) in currentRow[current.dataId]">
          <ul class="file__list">
            <li>
              <div class="file__icon">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                </svg>
              </div>
              <div class="file__info">
                <div class="file__info-name">
                  {{file.fileName}}
                </div>
                <div class="file__info-bottom">

                  <div class="file__info-size">
                    {{file.fileSize}}KB
                  </div>
                  <div class="file__info-handle">
                    <div
                      class="handle-button"
                      @click.stop.prevent.left="previewFile(file)">
                      预览
                    </div>
                    <div class="divider"></div>
                    <div
                      class="handle-button"
                      @click.stop.prevent.left="downloadFile(file)">
                      下载
                    </div>

                    <template v-if="isRead || isReadOnly">
                      <div class="divider"></div>
                      <div
                        class="handle-button"
                        @click="openFileAccessRecords(file.fileUrl)">
                        访问记录
                      </div>
                    </template>
                    <template v-if="!isRead && !isReadOnly">
                      <div class="divider"></div>
                      <div
                        style="color: red"
                        class="handle-button"
                        @click.stop.prevent.left="removeFile(idx)">
                        删除
                      </div>
                    </template>

                  </div>
                </div>
              </div>
            </li>
          </ul>
        </van-swipe-cell>

        <div
          v-if="isRead && (!currentRow[current.dataId] || !currentRow[current.dataId].length)">
          暂无内容
        </div>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__attachment-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
		  class="field-empty-tips"
            v-if="isRead && (!currentRow[current.dataId] || !currentRow[current.dataId].length)">
            暂无内容
          </div>
          <div v-else style="width: 100%">
            <van-button
              :loading="showLoading"
              v-if="!isRead"
              :disabled="isReadOnly"
              icon="upgrade"
              size="small"
              type="info"
              @click="selectFile">
              上传文件
            </van-button>
            <van-swipe-cell
              class="ry-form__file-item"
              v-for="(file, idx) in currentRow[current.dataId]">
              <ul class="file__list">
                <li>
                  <div class="file__icon">
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                    </svg>
                  </div>
                  <div class="file__info">
                    <div class="file__info-name">
                      {{file.fileName}}
                    </div>
                    <div class="file__info-bottom">

                      <div class="file__info-size">
                        {{file.fileSize}}KB
                      </div>
                      <div class="file__info-handle">
                        <div
                          class="handle-button"
                          @click.stop.prevent.left="previewFile(file)">
                          预览
                        </div>
                        <div class="divider"></div>
                        <div
                          class="handle-button"
                          @click.stop.prevent.left="downloadFile(file)">
                          下载
                        </div>

                        <template v-if="(isRead || isReadOnly) && $store.getters.userId">
                          <div class="divider"></div>
                          <div
                            class="handle-button"
                            @click="openFileAccessRecords(file.fileUrl)">
                            访问记录
                          </div>
                        </template>
                        <template v-if="!isRead && !isReadOnly">
                          <div class="divider"></div>
                          <div
                            style="color: red"
                            class="handle-button"
                            @click.stop.prevent.left="removeFile(idx)">
                            删除
                          </div>
                        </template>

                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </van-swipe-cell>
          </div>
        </template>
      </van-field>
    </div>

    <!--访问记录-->
    <file-access-records
      ref="fileAccessRecords"
      popupHeight="90%"
      overlay
      position="bottom"
    ></file-access-records>

    <file-preview-popup
      ref="filePreviewPopup"
      popupHeight="90%"
      overlay
      position="bottom"
    ></file-preview-popup>

    <gallery v-if="false" :id="`${current.dataId}_${index}`" :images="previewData" :index="previewIndex" @close="previewIndex = null"></gallery>

    <AtomListPreview :key="`${current.dataId}_${index}`" :visible="previewVisible" @close="closePreview" :dataList="previewData" :index="previewIndex"/>
  </div>

</template>

<script>
  import { current } from './mixin'
  import {fileType2FileImage} from "../../../../assets/js/Untis";
  import FileAccessRecords from "../../../component/mix_form/FileAccessRecords";
  import FilePreviewPopup from "../../../component/mix_form/FilePreviewPopup";
  import VueGallery from 'vue-gallery';

  export default {
    mixins: [current],
    components: {
      FileAccessRecords,
      FilePreviewPopup,
      'gallery': VueGallery
    },
    data () {
      return {
        dialogVisible: false,
        dialogImageUrl: '',
        showLoading: false,
        loadingPercentage: 0,
        fileInput: null,
        downloadEle: null,
        previewIndex: null,
        previewData: [],
        previewVisible: false,
      }
    },
    created () {
      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')
      this.fileInput = document.createElement('input')
      this.fileInput.setAttribute('type', 'file')
      if (this.current.allowFileType === 'YES') {
        this.fileInput.setAttribute('accept',
          this.current.fileTypeLimit
        )
      }
      this.fileInput.onchange = this.fileChange
    },
    computed: {},
    methods: {

      // file input change 事件触发
      fileChange (e) {
        const fileInfo = this.current.createFileInfo(e.target.files[0])
        if (
          this.current.sizeLimit &&
          fileInfo.imgSize > this.current.limitSize
        ) {
          this.$toast.fail('文件超出大小限制。')
          return
        }
        this.showLoading = true
        this.current.root.uploadFileMap[fileInfo.id] = true
        this.$RyFs.upload(e.target.files)
          .then(res => {
            fileInfo.fileUrl = res[0]
            this.currentRow[this.current.dataId].push(fileInfo)
            this.controlChange()
            this.showLoading = false
            this.settingWaterMark(res[0])
          })
          .catch(err => {
            console.error(err)
            this.showLoading = false
          })
          .finally(() => {
            this.current.root.uploadFileMap[fileInfo.id] = false
            this.fileInput.value = ''
          })
      },

      // 添加
      selectFile () {
        if (this.isReadOnly || this.showLoading) return
        this.fileInput.click()
      },

      // 删除文件
      removeFile (index) {
        if (this.isReadOnly) return
        this.$dialog.confirm({
          title: '确认信息',
          message: '是否确认删除？',
        })
          .then(() => {
            // on confirm
            this.currentRow[this.current.dataId].splice(index, 1)
            this.controlChange()
          })
          .catch(() => {
            // on cancel
          });

      },

      // 下载文件
      downloadFile (file) {
        if (window.isWexin || window.isWxWork || window.isLark) {
          this.$store.dispatch('reqNodeSave', file).then(res => {
            this.$router.push({
              name: 'attDownload',
              query: {
                key: res.nodeKey
              }
            })
          }).catch(console.error)

        } else {
          this.downloadEle.setAttribute('download', file.fileName)
          if (this.$store.getters.userId) {
            this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.getters.userId}`)
          } else {
            this.downloadEle.setAttribute('href', file.fileUrl)
          }
          this.downloadEle.click()
        }
      },

      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      previewFile(file) {

        if (['#icon-WAV','#icon-mp', '#icon-tupian'].includes(fileType2FileImage(file.fileType))) {
          this.previewData = this.currentRow[this.current.dataId] ? this.currentRow[this.current.dataId].map(file => {
            return {
              id: file.id,
              title: file.fileName,
              fileType: file.fileType ? file.fileType.split('/').slice(-1)[0] : '',
              href: file.fileUrl,
              poster: '',
              thumbnail: file.fileUrl
            }
          }).filter(item => ['#icon-WAV','#icon-mp', '#icon-tupian'].includes(fileType2FileImage(item.fileType))) : []
          this.previewData.forEach((item, idx) => {
            if (item.id === file.id) {
              this.previewIndex = idx
            }
          })

          if (this.previewData.length && this.previewIndex >= 0 && this.previewIndex < this.previewData.length) {
            this.previewVisible = true
            return
          }
        }
        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'FLOW_FORM')
        }

        /*

         const loading = this.$toast.loading()
        this.$store.dispatch('actionNodeSave', {
          ...file,
          preview_type: 'FLOW_FORM',
          userId: this.$store.getters.userId,
          companyId: this.$store.getters.currentCompanyId,
          token: this.$store.state.token
        }).then(res => {
          this.$router.push({
            name: 'filePreview',
            query: {
              k: res.nodeKey
            }
          })
        }).catch(console.error)
          .finally(() => {
            loading.clear()
          })
        * */
      },

      openFileAccessRecords(fileUrl) {
        if (this.$refs.fileAccessRecords) {
          this.$refs.fileAccessRecords.open(fileUrl)
        }
      },

      async settingWaterMark(url) {
        if (!this.current.openWaterMark || this.current.openWaterMark === 'NO') {
          return
        }
        if (!url) {
          return
        }
        const arrTmp = url.split('/')
        if (arrTmp.length <= 1) {
          return
        }
        const fileKey = arrTmp[arrTmp.length - 1]

        let fileType = sessionStorage.getItem(`${this.$store.getters.currentCompanyId}_fileType`)

        if (!fileType) {
          const res = await this.$store.dispatch('actionCompanyFileType').catch(console.error)

          fileType = res.fileType
          sessionStorage.setItem(`${this.$store.getters.currentCompanyId}_fileType`, fileType)
        }

        if (fileType === 'QINIU') {
          const formSet = this.current.root
          this.$store.dispatch('actionFileWaterMarkHandle', {
            appId: formSet.appId,
            formId: formSet.formId,
            fieldId: this.current.dataId,
            data: formSet.getValues(),
            fileKey
          }).catch(console.error)
        }
      },
      closePreview() {
        this.previewIndex = null
        this.previewVisible = false
      }
    }
  }
</script>

<style lang="less">

  .ry-form-item__attachment {

    .van-cell__value {
      width: calc(100% - 100px);
    }

    .normal-style {

      .van-cell__title {
        width: 100%;
      }
    }

    .file__list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      list-style: none;
      margin: 0;
      padding: 0;

      > li {
        list-style: none;
        width: calc(100% - 10px);
        min-height: 40px;
        margin: 5px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e6e6e6;


        > .file__icon {
          text-align: center;

          .icon {
            width: 30px;
            height: 30px;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden;
            margin-right: 10px;
            margin-top: 5px;
          }
        }

        > .file__info {
          width: calc(100% - 40px);
          display: flex;
          flex-direction: column;

          > .file__info-name {
            line-height: 20px;
            color: #495060;
            font-size: 13px;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }

          > .file__info-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;

            > .file__info-size {
              height: 20px;
              line-height: 20px;
              font-size: 11px;
              color: #909399;
            }

            > .file__info-handle {
              display: flex;
              align-items: center;

              .divider {
                height: 16px;
                width: 1px;
                background-color: #e6e6e6;
                margin: 0 5px;
              }
            }
          }
        }
      }
    }
  }
</style>